export interface BlogPost {
  slug: string;
  title: string;
  excerpt: string;
  date: string;
  author: string;
  content: string;
}

export const blogPosts: BlogPost[] = [
  {
    slug: 'ecommerce-in-the-ai-era',
    title: 'eCommerce in the AI Era: Why the Traditional Way Is No Longer Enough',
    excerpt:
      'Search bars, static product grids, and one-size-fits-all funnels built the first generation of online stores. In the AI era, they have become the ceiling rather than the foundation. Here is where eCommerce is heading next.',
    date: 'June 20, 2026',
    author: 'AiDA Team',
    content: `For several decades, eCommerce ran on a familiar playbook: a search bar, a grid of products, a few filters, and a checkout funnel optimized one A/B test at a time. It worked because shoppers had no better option. Today, that playbook has quietly become the ceiling rather than the foundation.

The traditional model assumes the customer already knows what they want and is willing to do the work of finding it. But most people don't arrive with a product name in mind — they arrive with a problem, a budget, an occasion, or a vague preference. Keyword search can't interpret "something warm for a rainy hiking trip under $80." Static category pages can't ask a follow-up question. The result is friction: endless scrolling, abandoned carts, and support tickets that pile up after the sale.

So what is the direction?

The next era of eCommerce is conversational and context-aware. Instead of forcing shoppers through rigid menus, AI assistants understand intent in natural language, ask clarifying questions, and guide customers to the right choice the way a knowledgeable salesperson would. Personalization moves beyond "customers also bought" toward genuine understanding of each shopper's goals, history, and constraints.

Just as importantly, AI collapses the gap between sales and support. The same assistant that helps a customer choose a product can answer questions about shipping, handle a return, or recommend a complement — all in one continuous conversation, available around the clock.

This is exactly the shift AiDA is built for. By integrating with your existing products, processes, and data, AiDA turns a static storefront into an intelligent, responsive experience — one that meets customers where they are and helps them get what they actually came for.
`,
  },
];

export const getBlogPost = (slug: string): BlogPost | undefined =>
  blogPosts.find((post) => post.slug === slug);
